import { render, staticRenderFns } from "./newWarehouseIcon.vue?vue&type=template&id=11960b58"
import script from "./newWarehouseIcon.vue?vue&type=script&lang=js"
export * from "./newWarehouseIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports